export const TOTAL_SECTIONS = 6
export const SECTION_PROGRESS_GREEN = '#34C85A'
